import { useEffect, useRef, useState } from "react";

type Props = {
  title: string,
  text: string,
  url: string | null,
  focalPoint: {
    x: number,
    y: number
  } | null,
  left: boolean
};

export default function MarketingParagraph({ title, text, url, focalPoint, left }: Props) {
  const ref = useRef<HTMLDivElement>(null); // Initialize the ref with a null value
  const [height, setHeight] = useState<string>('30px'); // Initial border radius

  useEffect(() => {
    if (ref.current) {
      setHeight(ref.current.offsetHeight + "px");
    }
  }, []); // Empty dependency array ensures this effect runs once after initial mount

  return (
    <div style={{ alignContent: "center", width: "100%" }}>
      <div style={{
        marginTop: "60px",
        marginBottom: "60px",
        display: 'flex',
        flexDirection: left ? 'row-reverse' : 'row',
        
        position: "relative",
        left: "50%",
        transform: "translateX(-50%)",  // This will center the div
        width: "80%"
      }} ref={ref}>
        <div style={{
          flex: 1,
          borderTopLeftRadius: `calc(0.5 * ${height})`, // Apply dynamic radius
          borderTopRightRadius: `calc(0.5 * ${height})`,
          borderBottomLeftRadius: (left) ? `calc(0.1 * ${height})` : `calc(0.5 * ${height})`,
          borderBottomRightRadius: (left) ? `calc(0.5 * ${height})` : `calc(0.1 * ${height})`,

          backgroundImage: `url('${url ?? "https://images.pexels.com/photos/2280547/pexels-photo-2280547.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"}')`,
          backgroundSize: "cover",
          backgroundPosition: `${(focalPoint?.x ?? 0) * 100}% ${(focalPoint?.y ?? 0) * 100}%`,
          backgroundRepeat: "no-repeat",
        }}>
        </div>
        <div style={{flex: 0.1}}> </div>
        <div style={{
          flex: 1,
          paddingLeft: '10px',
          paddingRight: '10px',
          paddingTop: '40px',
          paddingBottom: '40px',
        }}>
          <h1>{title}</h1>
          <div className="content">{text}</div>
        </div>
      </div>
    </div>
  );
}